import React from 'react';
import {
  Avatar,
  Box,
  Chip,
  Typography,
} from '@mui/material';

import { IJobListing } from '../../services/serviceJobsAccount/interfaces';
import { JobPublicationDetails } from './JobPublicationDetails';

const withoutMarkup = (value: string): string => value.replace(/<[^>]*>/g, '');

interface IListingDetailsProps {
  listing: IJobListing;
  isActive: boolean;
}

export const ListingDetails = ({ listing, isActive }: IListingDetailsProps) => {
  const title = withoutMarkup(listing.title || '');

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, minWidth: 280 }}>
      {listing.image ? (
        <Avatar
          src={listing.image}
          alt=""
          variant="rounded"
          sx={{ width: 64, height: 64, bgcolor: 'background.paper' }}
        />
      ) : null}
      <Box>
        <JobPublicationDetails
          title={title}
          path={listing.path}
          siteId={listing.siteId}
          isActive={isActive}
          titleSx={{ fontWeight: 700 }}
        />
        <Chip
          label={listing.isFeatured ? 'Featured Listing' : 'Standard Listing'}
          size="small"
          variant={listing.isFeatured ? 'filled' : 'outlined'}
          sx={{
            backgroundColor: listing.isFeatured ? 'var(--alert-soft)' : 'var(--bg)',
            borderColor: listing.isFeatured ? 'var(--alert)' : 'var(--line-divider)',
            borderRadius: 0,
            color: listing.isFeatured ? 'var(--alert-deep)' : 'var(--ink-3)',
            fontSize: '0.8rem',
            fontWeight: 700,
            height: 24,
            mt: 0.75,
          }}
        />
        {listing.shortDescription ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {listing.shortDescription}
          </Typography>
        ) : null}
        {listing.location ? (
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
            {listing.location}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default ListingDetails;
